/**
 * The direction the widget transitions in from: the side Spotlight is
 * positioned on, otherwise from the bottom.
 */
export const getSpotlightTransitionDirection = position => position === 'left' || position === 'right' ? position : 'bottom';